export default "__VITE_ASSET__MhpOHp5Y__"